import { SALE_MEMBER_OPPORTUNITY_URL } from './headerContract';

export const PUBLIC_WEBSITE_URL = 'https://maimai.cn/';
export const DOWNLOAD_URL = 'https://taou.cn/show_open?type=home';
export const LOGO_URL = 'https://bs.taou.com/static/images/website/pc/logo.png';
export const SEARCH_ICON_URL = 'https://i9.taou.com/maimai/p/36330/1133_6_81FU9SswEDcZRo5M';
export const BUSINESS_ARROW_URL = 'https://i9.taou.com/maimai/p/28279/563_6_81YQLNlxyuxSfVBm';
export const BUSINESS_MENU_TRIANGLE_URL = 'https://i9.taou.com/maimai/p/28277/8725_6_14hQx4yeDeu0rQ';
export const RECRUITER_BADGE_URL = 'https://i9.taou.com/maimai/p/32780/7664_6_ILfXHLfWBwIwnY';
export const PC_VIDEO_URL = 'https://f9.taou.com/landing/pc_index_small_new.mp4';
export const REFERRAL_IMAGE_URL = 'https://i9.taou.com/maimai/p/39390/2747_6_31kd4pzSuQ8ahyJU';
export const REFERRAL_CLOSE_URL = 'https://i9.taou.com/maimai/p/38764/325_6_14eQK4Mewer0oQ';
export const REFERRAL_URL = 'https://maimai.cn/n/job/b/referral-opportunity?asset=referral_award_2026_06';

export const WEBSITE_SEO = {
  title: '脉脉-成就职业梦想',
  description:
    '1.2亿职场人都在用的职场社区和求职平台，基于“实名/职业认证”和“人脉网络引擎”帮助职场人拓展人脉、交流合作、求职招聘，收获更多机遇。',
  keywords: '脉脉,脉脉官网,脉脉APP,maimai,招聘,找人,合作,商务,升职,加薪,找工作,职言,社交,交友',
  shareImage: 'https://i9.taou.com/maimai/p/36629/8007_6_21TYlXVpv5SH8sH0',
} as const;

export function buildLoginUrl(publicDestination: string) {
  return `/platform/login?to=${encodeURIComponent(publicDestination)}`;
}

export const PROTECTED_DESTINATIONS = {
  chat: 'https://maimai.cn/chat',
  company: 'https://maimai.cn/ent/v2/company/home',
  marketing: 'https://maimai.cn/n/ad/marketing-center/home',
} as const;

export const businessMenuItems = [
  {
    title: '人才银行',
    description: '驾驭数字化与社交化招聘趋势',
    href: 'https://maimai.cn/jobs/talent_bank_land?fr=maiin_index',
  },
  {
    title: '脉脉人才智库',
    description: '吸引人才，赢得人心',
    href: 'https://maimai.cn/jobs/data?fr=maiin_index',
  },
  {
    title: '脉脉数字营销',
    description: '职场社区品牌营销首选平台',
    href: 'https://maimai.cn/n/platform/ad/digital-market-index',
  },
  {
    title: '拓客通',
    description: '销售必备拓客神器',
    href: SALE_MEMBER_OPPORTUNITY_URL,
    memberAware: true,
  },
  {
    title: '脉脉专家网络',
    description: '致力于打造B2B级知识学习平台',
    href: 'https://maimai.cn/bizmember/activity/expert_homepage_pc',
  },
  {
    title: '企业号',
    description: '雇主品牌宣传阵地',
    href: 'https://maimai.cn/company/marketing?fr=main_index',
  },
] as const;

export const serviceStripItems = [
  {
    src: 'https://i9.taou.com/maimai/p/34036/3491_6_71oQgNzxlu4SUV3m',
    alt: '人才解决方案：社交求职时代的职场与人才趋势',
    href: 'https://maimai.cn/jobs/data?fr=main_index',
    position: 'left',
  },
  {
    src: 'https://i9.taou.com/maimai/p/35456/3386_6_2QJ2fE1oaeWA6c',
    alt: '广告合作：脉脉数字营销解决方案介绍',
    href: 'https://maimai.cn/n/platform/ad/digital-market-index',
    position: 'center',
  },
  {
    src: 'https://i9.taou.com/maimai/p/34030/8900_6_52FvNLh77Xjn7GRY',
    alt: '我要招人：中高端人才招聘专属渠道',
    href: 'https://maimai.cn/n/platform/gaopin',
    position: 'right',
  },
] as const;

export const SERVICE_SEPARATOR_URL = 'https://i9.taou.com/maimai/p/34036/3490_6_61scz0NLm1dMupP6';
export const VIDEO_TRIGGER_IMAGE_URL = 'https://i9.taou.com/maimai/p/34018/6438_6_4J8CxQeHBkgxf6';
export const VIDEO_COPY_IMAGE_URL = 'https://i9.taou.com/maimai/p/34022/9345_6_1QqnNArtuKKTCW';

export interface PcFeatureAsset {
  src: string;
  alt: string;
}

export interface PcFeature {
  id: 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
  left: PcFeatureAsset;
  right: PcFeatureAsset;
}

export const pcFeatures: readonly PcFeature[] = [
  {
    id: 2,
    left: {
      src: 'https://i9.taou.com/maimai/p/34021/5035_6_11jd3pNStQUaAybU',
      alt: '海量用户职业身份认证，助力中国职场人塑造个人职业形象',
    },
    right: {
      src: 'https://i9.taou.com/maimai/p/32853/4633_6_82Ipe0buUStlcKvk',
      alt: '脉脉实名职业身份认证展示',
    },
  },
  {
    id: 3,
    left: {
      src: 'https://i9.taou.com/maimai/p/34022/7628_6_413gW5yKIaTSiSPw',
      alt: '脉脉同事圈职业社区展示',
    },
    right: {
      src: 'https://i9.taou.com/maimai/p/34021/5773_6_925vVqobwRMRwnbe',
      alt: '同事圈：在圈子找到职场归属感',
    },
  },
  {
    id: 4,
    left: {
      src: 'https://i9.taou.com/maimai/p/34021/6009_6_42Kpz0ruaSOlLK1k',
      alt: '最热、最全的职场话题，有用、有料的职场干货',
    },
    right: {
      src: 'https://i9.taou.com/maimai/p/34021/5555_6_11xQtNZxtuCSVVZm',
      alt: '脉脉职场话题和职场干货展示',
    },
  },
  {
    id: 5,
    left: {
      src: 'https://i9.taou.com/maimai/p/34021/6117_6_2FZdx2kaO6aaz8',
      alt: '脉脉公司点评展示',
    },
    right: {
      src: 'https://i9.taou.com/maimai/p/34021/6230_6_5JSCXQ6HlkPxq6',
      alt: '公司点评：先看点评，再找工作',
    },
  },
  {
    id: 6,
    left: {
      src: 'https://i9.taou.com/maimai/p/34022/4645_6_14sQe4ReueI0RQ',
      alt: '三大人才服务，多场景覆盖',
    },
    right: {
      src: 'https://i9.taou.com/maimai/p/34022/4646_6_2JnCVQDHtkAxg6',
      alt: '脉脉人才服务展示',
    },
  },
  {
    id: 7,
    left: {
      src: 'https://i9.taou.com/maimai/p/34023/4861_6_719UjS4wLD4Zao7M',
      alt: '脉脉人才银行展示',
    },
    right: {
      src: 'https://i9.taou.com/maimai/p/34022/4957_6_32rv7qobfRTRGnXe',
      alt: '人才银行：人才全生命周期管理',
    },
  },
  {
    id: 8,
    left: {
      src: 'https://i9.taou.com/maimai/p/34022/4955_6_11zdJpQSiQaaSyvU',
      alt: '雇主品牌服务：推动企业与人才的良性互动',
    },
    right: {
      src: 'https://i9.taou.com/maimai/p/34022/4959_6_5JihuUWBdOCdvm',
      alt: '脉脉雇主品牌服务展示',
    },
  },
  {
    id: 9,
    left: {
      src: 'https://i9.taou.com/maimai/p/34022/4958_6_44mvO8a8eHLH66',
      alt: '脉脉专家网络展示',
    },
    right: {
      src: 'https://i9.taou.com/maimai/p/34022/4956_6_21vQqsCBhp2mhBJC',
      alt: '脉脉专家网络：企业的外部人力资源，覆盖500多个细分行业',
    },
  },
] as const;

export const TESTIMONIAL_TITLE_URL = 'https://i9.taou.com/maimai/p/32853/3734_6_rJjC5QUHFkNxV6';

export const testimonials = [
  {
    avatar: 'https://i9.taou.com/maimai/p/30824/248_6_42ckMAyz2DoItXRa',
    quote:
      '美国职场人用社交平台找工作拓人脉，中国此类习惯也正在形成。欢迎大家一起用脉脉，交流工作技能，分享职场观点，成就职业梦想！',
    author: '程彤博',
    role: '蜻蜓fm战略项目经理',
  },
  {
    avatar: 'https://i9.taou.com/maimai/p/30824/309_6_4FLdY2naC6TaO8',
    quote:
      '自从用了脉脉，有了和行业大咖们交流的机会，在脉脉上分享行业观点经常会碰撞出许多思想的火花，希望和脉脉在这个平台上一同成长。',
    author: '徐玮',
    role: 'Facebook商业化增长负责人',
  },
  {
    avatar: 'https://i9.taou.com/maimai/p/30824/346_6_2Ql2YELoFeRAmc',
    quote:
      '在脉脉招到了20多位精英，收获了行业人脉和志趣相投的朋友。洞悉行业变化、职场进阶、拓展人脉都可以有，推荐给身边上进的人。',
    author: '安添蕾',
    role: 'Bilibili运营总监',
  },
  {
    avatar: 'https://i9.taou.com/maimai/p/30824/463_6_87Ya9ZDt8qX0QIn',
    quote: '跟同行和兴奋点相同的人一起聊天，屏蔽掉〝话不投机〞的联系人。我在脉脉等你来，跟〝懂你〞的人一起High!',
    author: '李海寅',
    role: '腾讯高级研发工程师',
  },
  {
    avatar: 'https://i9.taou.com/maimai/p/30824/493_6_91fUsSFw8DCZFolM',
    quote:
      '在脉脉，了解更多职人百态，分享追逐疲惫英雄梦的初心，拓宽认知边界，随手一刷轻松get职场妙招，还有各色HR段子手的逗趣B面。',
    author: '王龙栏',
    role: '百度AI产品运营经理',
  },
  {
    avatar: 'https://i9.taou.com/maimai/p/30824/550_6_6J5CTQoHNkGxn6',
    quote:
      '在脉脉上每次分享工作的见解和日常，都有很多可爱的同行来互动，通过发布专栏文章，还招到很多读者一起工作，简直不能更棒好吗。',
    author: '许苏亚',
    role: '百度资深设计师',
  },
] as const;

export const organizationStructuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://maimai.cn/#organization',
      name: '北京淘友天下科技发展有限公司',
      alternateName: '脉脉',
      url: PUBLIC_WEBSITE_URL,
      logo: LOGO_URL,
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+86-400-065-0808',
        email: 'maimai@taou.com',
        contactType: 'customer service',
      },
    },
    {
      '@type': 'WebSite',
      '@id': 'https://maimai.cn/#website',
      url: PUBLIC_WEBSITE_URL,
      name: '脉脉',
      description: WEBSITE_SEO.description,
      publisher: {
        '@id': 'https://maimai.cn/#organization',
      },
    },
  ],
} as const;
